var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65015 0.166656C9.06517 0.166764 9.46488 0.331 9.76245 0.628571L13.5378 4.41275C13.8353 4.70256 13.9998 5.10219 13.9998 5.51724V14.2663C13.9998 15.1279 13.295 15.8336 12.4333 15.8336H3.02515C2.16359 15.8335 1.46655 15.1279 1.46655 14.2663V1.73306C1.4667 0.871602 2.1715 0.166801 3.03296 0.166656H8.65015ZM9.08862 4.1315C9.08865 4.51254 9.39997 4.82384 9.78101 4.82388H12.8992L9.08862 1.01334V4.1315Z",
    fill: "#DFDEFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.34668,
    y: 5.64999,
    width: 4.70001,
    height: 0.783335,
    rx: 0.391668,
    fill: "#292E52"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.34668,
    y: 10.35,
    width: 8.61669,
    height: 0.783335,
    rx: 0.391668,
    fill: "#292E52"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.34668,
    y: 8,
    width: 8.61669,
    height: 0.783335,
    rx: 0.391668,
    fill: "#292E52"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.34668,
    y: 12.7,
    width: 8.61669,
    height: 0.783335,
    rx: 0.391668,
    fill: "#292E52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentIcon);
export default __webpack_public_path__ + "static/media/assignment-icon.c79048af.svg";
export { ForwardRef as ReactComponent };